/* global axios */
import ApiClient from '../ApiClient';

// Prime Insight — per-account AI provider configuration (BYO key: OpenRouter/
// OpenAI/Google). Replaces the old global env-based OPENROUTER_API_KEY.
class MetricaAiProviderConfigAPI extends ApiClient {
  constructor() {
    super('metrica', { accountScoped: true });
  }

  show() {
    return axios.get(`${this.url}/ai_provider_config`);
  }

  connect(provider, apiKey) {
    return axios.post(`${this.url}/ai_provider_config/connect`, {
      provider,
      api_key: apiKey,
    });
  }

  // Re-checks a connected provider's key against the live API on demand (the
  // stored "N modelos" label is written once at connect time and never
  // refreshed, so it can keep showing green while the key is already dead).
  revalidate(provider) {
    return axios.post(`${this.url}/ai_provider_config/revalidate`, {
      provider,
    });
  }

  disconnect(provider) {
    return axios.delete(`${this.url}/ai_provider_config/${provider}`);
  }

  updateCapabilities(capabilities) {
    return axios.patch(`${this.url}/ai_provider_config/capabilities`, {
      capabilities,
    });
  }
}

export default new MetricaAiProviderConfigAPI();
